const ListOfTrials = [
  {
    title: 'Alert',
    description: `A simple alert`,
    url: 'alert',
    componentName: `<Alert/>`
  },
  {
    title: 'Alert Dialog',
    description: `A simple alert dialog`,
    url: 'alert-dialog',
    componentName: `<AlertDialog/>`
  },
  {
    title: 'Breadcrumb',
    description: `A Breadcrumb trial`,
    url: 'breadcrumb',
    componentName: `<Breadcrumb/>`
  },
  {
    title: 'Customer Dashboard',
    description: `Customer facing dashboard . Built to practice Accordion`,
    url: 'customers',
    componentName: `<Customers/>`
  }, {
    title: 'ShoppingCard',
    url: 'shopping-card',
    description: 'A simple shopping card , built to practice nested interaction ',
    componentName: `<ShoppingCard/>`
  }
];

export {
  ListOfTrials
};